import React from 'react';
import { Modal, Button, Badge } from '@/components/ui';
import type { AgentPromptVersion } from '@/services/admin/AdminService';

interface VersionDiffProps {
  open: boolean;
  onClose: () => void;
  version: AgentPromptVersion | null;
  currentVersion: string;
}

export const VersionDiff: React.FC<VersionDiffProps> = ({
  open,
  onClose,
  version,
  currentVersion,
}) => {
  if (!version) return null;

  const isActive = version.version === currentVersion;

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={`Version ${version.version}`}
      maxWidth="lg"
      actions={
        <Button variant="outline" onClick={onClose}>
          Close
        </Button>
      }
    >
      <div className="space-y-4">
        <div className="flex items-center gap-3">
          {isActive ? (
            <Badge variant="success">Active Version</Badge>
          ) : (
            <Badge variant="default">Historical Version</Badge>
          )}
          <span className="text-sm text-secondary-500">
            Created {new Date(version.created_at).toLocaleDateString()} by{' '}
            {version.created_by}
          </span>
        </div>

        <div>
          <h4 className="text-sm font-medium text-secondary-700 mb-1">
            Description
          </h4>
          <p className="text-secondary-600">{version.description}</p>
        </div>

        {version.performance_notes && (
          <div>
            <h4 className="text-sm font-medium text-secondary-700 mb-1">
              Performance Notes
            </h4>
            <p className="text-secondary-600 italic">
              {version.performance_notes}
            </p>
          </div>
        )}

        <div>
          <h4 className="text-sm font-medium text-secondary-700 mb-2">
            Prompt Template
          </h4>
          <div className="border border-secondary-200 rounded-lg p-4 bg-secondary-50 max-h-96 overflow-y-auto">
            <pre className="whitespace-pre-wrap text-sm text-secondary-700 font-mono">
              {version.prompt_template}
            </pre>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default VersionDiff;
